import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center no_node_selected bg-zinc-900"
}
const _hoisted_2 = {
  key: 1,
  class: "dark bg-zinc-900 m-1 p-2"
}
const _hoisted_3 = { class: "grid-x" }
const _hoisted_4 = { class: "cell shrink text-xs" }
const _hoisted_5 = { class: "node_name_container text-center" }
const _hoisted_6 = { class: "node_name hover:text-white" }
const _hoisted_7 = { class: "cell auto text-right" }
const _hoisted_8 = {
  key: 0,
  class: "prose dark:prose-invert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_ArrowUpRightIcon = _resolveComponent("ArrowUpRightIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NodeDocComponent = _resolveComponent("NodeDocComponent")!

  return (_openBlock(), _createElementBlock("div", {
    class: "Panel NodeDocs max-h-full overflow-y-auto grid-y bg-bg-medium text-text",
    onPointermove: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.on_pointer_move && _ctx.on_pointer_move(...args)))
  }, [
    (!_ctx.JSONNode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_EmptyState, {
            displayEmoji: false,
            title: "Quick Docs",
            subtitle: "Select any node to display its documentation"
          })
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.JSONNode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.nodeName) + ":", 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.nodeDocUrl)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "cursor-pointer px-2 text-xs text-text-faded hover:text-text-light",
                    to: _ctx.nodeDocUrl,
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowUpRightIcon, { class: "inline-block h-4 w-4" })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["to"]))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          (_ctx.nodeContext && _ctx.nodeType)
            ? (_openBlock(), _createElementBlock("article", _hoisted_8, [
                _createVNode(_component_NodeDocComponent, {
                  context: _ctx.nodeContext,
                  type: _ctx.nodeType
                }, null, 8 /* PROPS */, ["context", "type"])
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ], 32 /* HYDRATE_EVENTS */))
}